import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const MapPage = ({ language }) => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_PAGES_CHARGING_TITLE} - Austin Energy EV Buyers Guide`;
  });

  return (
    <section className="container">
      <div>
        <zr-charging-stations-widget
          lang={language?.toLowerCase() ?? 'en'}
        ></zr-charging-stations-widget>
      </div>
    </section>
  );
};

export default MapPage;

MapPage.propTypes = {
  language: PropTypes.string,
};
